const CURSOR_ID_LENGTH = 16;

function normalizeInput(publishDateOrRow, inputId) {
    if (publishDateOrRow && typeof publishDateOrRow === 'object' && !(publishDateOrRow instanceof Date)) {
        return {
            publishDate: publishDateOrRow.publishDate,
            id: publishDateOrRow.id,
        };
    }
    return { publishDate: publishDateOrRow, id: inputId };
}

export function buildCursorKey(publishDateOrRow, inputId) {
    const { publishDate, id } = normalizeInput(publishDateOrRow, inputId);
    const date = new Date(publishDate);
    const numericId = Number(id);
    if (!publishDate || Number.isNaN(date.getTime()) || !Number.isSafeInteger(numericId) || numericId < 0) {
        return null;
    }
    return `${date.toISOString()}#${String(numericId).padStart(CURSOR_ID_LENGTH, '0')}`;
}

export function compareCursorKeys(first, second) {
    if (!first && !second) return 0;
    if (!first) return -1;
    if (!second) return 1;
    return String(first).localeCompare(String(second));
}

export function newestCursorForRows(rows = []) {
    return rows.reduce((newest, row) => {
        const cursor = buildCursorKey(row);
        return compareCursorKeys(cursor, newest) > 0 ? cursor : newest;
    }, null);
}

export { CURSOR_ID_LENGTH };
